export default __webpack_public_path__ + "static/media/snap.baa2af96.svg";